// extracted by mini-css-extract-plugin
export default {"warning":"dayEditPopup_warning__cH61U"};